<template>
  <ComboPicker
    :label="orientation == 'horizontal' ? null : label"
    strings="tipo"
    icon="mdi-tune"
    :bothIcons="orientation == 'horizontal'"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todos os tipos' : '(Todos)'"
    types="grouped-items"
    :tags="[]"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { RawdataEvent } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Tipo de Registro' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  methods: {
    async fetchData() {
      let allTypes = await RawdataEvent.findTypes()
      allTypes = orderBy(allTypes, [['type', 'asc']])
      this.allItems = allTypes.map((row) => {
        return { id: row.type, name: row.type }
      })
    }
  }
}
</script>

<style></style>
